module.exports = __webpack_public_path__ + "static/media/welcomeCardBackground.19e16ee0.jpg";